"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.384 1.42a4.58 4.58 0 0 0-6.38.45 4.59 4.59 0 0 0-6.39-.45 4.57 4.57 0 0 0-.53 6.44l5.61 6.62.65-.77-5.5-6.49a3.58 3.58 0 0 1 2.72-5.89h.31a3.56 3.56 0 0 1 2.43 1.26l.31.37a.53.53 0 0 0 .77 0l.31-.37a3.58 3.58 0 0 1 5.46 4.62l-2.52 3-4.29 5.06.27.32a.499.499 0 0 0 .77 0l6.53-7.72a4.57 4.57 0 0 0-.53-6.44v-.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.457 2.205a6.683 6.683 0 0 0-9.412.75L12 3.008l-.037-.053A6.676 6.676 0 0 0 1.77 11.58l8.738 10.373.75-.87-8.633-10.2a5.55 5.55 0 1 1 8.467-7.17l.473.555a.584.584 0 0 0 .863 0l.472-.555a5.55 5.55 0 1 1 8.467 7.17l-9.36 11.07-.75.862.308.36a.555.555 0 0 0 .667.148.585.585 0 0 0 .196-.148l9.794-11.572a6.675 6.675 0 0 0-.765-9.398Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.61 2.94a8.91 8.91 0 0 0-12.55 1l-.06.07-.05-.07a8.901 8.901 0 1 0-13.59 11.5l11.65 13.83 1-1.16L3.5 14.51a7.4 7.4 0 1 1 11.29-9.56l.63.74a.78.78 0 0 0 1.15 0l.63-.74a7.4 7.4 0 1 1 11.29 9.56L16.01 29.27l-1 1.15.41.48a.738.738 0 0 0 .889.197.78.78 0 0 0 .261-.197l13.06-15.43a8.9 8.9 0 0 0-1.02-12.53Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.767 13.335a13.365 13.365 0 0 0-23.52-7.538L24 6.082l-.247-.285a13.365 13.365 0 0 0-20.4 17.25l18.194 21.518 1.223-1.447-18-21.24A11.497 11.497 0 0 1 22.313 7.02l.96 1.14a.937.937 0 0 0 1.425 0l.96-1.14A11.497 11.497 0 1 1 43.2 21.877L28.882 38.76l-6.127 7.237.518.608a.939.939 0 0 0 1.425 0l19.934-23.528a13.312 13.312 0 0 0 3.136-9.742Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.69 17.78A17.82 17.82 0 0 0 32.33 7.73l-.33.38-.33-.38a17.82 17.82 0 0 0-27.2 23l24.26 28.69 1.63-1.93-24-28.32A15.33 15.33 0 0 1 29.75 9.36l1.28 1.52a1.25 1.25 0 0 0 1.9 0l1.28-1.52A15.33 15.33 0 1 1 57.6 29.17L38.51 51.68l-8.17 9.65.69.81a1.252 1.252 0 0 0 1.9 0l26.58-31.37a17.75 17.75 0 0 0 4.18-12.99Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconHeart = function IconHeart(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Heart' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Heart"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconHeart.sizes = [16, 24, 32, 48, 64];
IconHeart.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconHeart;
exports.default = _default;